import { Component } from "react";
import { Row, Col, Form, Button, Toast } from "react-bootstrap";

import "./contact-meStyle.scss";

import React from "react";
import { openAnotherTab } from "../../shared/utils/redirectUtils";
import BackComponent from "../../shared/components/backComponent/back";

class ContactMe extends Component {
  state = {
    email: "",
    subject: "",
    message: "",
    toastMesssage: "",
  };

  onInputChange(event) {
    event.preventDefault();

    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  onSubmit() {
    const { email, message } = this.state;
    const tempalteId = "template_ognGDcca";
    const service = "PortfolioBot";

    const to_name = "Andrei";
    const variables = {
      message_html: message,
      from_name: email,
      to_name,
    };

    window.emailjs
      .send(service, tempalteId, variables)
      .then(() =>
        this.displayToastMessage(
          "I just received your email, I will come with a response as fast as possible."
        )
      )
      .catch((err) =>
        this.displayToastMessage(
          "It seems that there is an error with the email service :(, but you can contact me on the above provided accounts."
        )
      )
      .finally(() => {
        const currentIP = this.state.userIp;

        let currentNumberOfSends = +localStorage.getItem(currentIP) || 0;
        localStorage.setItem(currentIP, (currentNumberOfSends += 1));
      });
  }

  isValidByIp() {
    const currentIP = this.state.userIp;
    const maxSends = 2;

    return (+localStorage.getItem(currentIP) || 0) <= maxSends;
  }

  displayToastMessage(toastMesssage) {
    const messageDuration = 5000;
    this.setState({
      toastMesssage,
    });

    setTimeout(() => this.setState({ toastMesssage: "" }), messageDuration);
  }

  componentDidMount() {
    fetch("https://www.cloudflare.com/cdn-cgi/trace")
      .then((rawData) => rawData.text())
      .then((data) => {
        const userIp = data.split("ip=")[1].split("\n")[0];
        this.setState({ userIp });
      });
  }

  isEmailValid(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  isValidInput(inputString) {
    return inputString.length > 3;
  }

  isValidForm() {
    const { email, subject, message } = this.state;

    return (
      this.isValidByIp() &&
      email !== "" &&
      this.isEmailValid(email) &&
      subject !== "" &&
      this.isValidInput(subject) &&
      message !== "" &&
      this.isValidInput(message)
    );
  }

  render() {
    const { history } = this.props;
    const { email, subject, message, toastMesssage } = this.state;

    return (
      <div className="contact-me">
        <Row>
          <Col sm={0} md={4} lg={6}>
            <div className="contact-me__form">
              <BackComponent className="contact-me__form__back" />
              <Form className="contact-me__form--wrapper">
                <Form.Row>
                  <Col xs={12}>
                    <Toast
                      style={{
                        display: `${toastMesssage !== "" ? "inherit" : "none"}`,
                      }}
                      onClose={() => this.setState({ toastMesssage: "" })}
                      className="toaster"
                      show={toastMesssage !== ""}
                    >
                      <Toast.Header>
                        <img
                          src="holder.js/20x20?text=%20"
                          className="rounded mr-2"
                          alt=""
                        />
                        <strong className="mr-auto"></strong>
                      </Toast.Header>
                      <Toast.Body>{toastMesssage}</Toast.Body>
                    </Toast>
                    <Form.Group>
                      <Form.Label>Email*</Form.Label>
                      <Form.Control
                        onChange={this.onInputChange.bind(this)}
                        placeholder="email@email.com"
                        value={email}
                        name="email"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Subject*</Form.Label>
                      <Form.Control
                        onChange={this.onInputChange.bind(this)}
                        placeholder="Nice design! :D"
                        value={subject}
                        name="subject"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Message*</Form.Label>
                      <Form.Control
                        onChange={this.onInputChange.bind(this)}
                        placeholder="Let's get in touch!"
                        value={message}
                        name="message"
                        as="textarea"
                      />
                    </Form.Group>
                  </Col>
                </Form.Row>
              </Form>
              <Button
                className="contact-me__form__button"
                variant="dark"
                onClick={() => this.onSubmit()}
                disabled={!this.isValidForm()}
              >
                submit{" "}
                <img
                  className="contact-me__next-icon"
                  src={require("../../public/static/next.svg")}
                  alt="Next icon"
                />
              </Button>
            </div>
          </Col>
          <Col sm={0} md={4} lg={6}>
            <div className="contact-me--right">
              <div className="contact-me--right__image-wrapper">
                <div className="contact-me--right__text">Contact me</div>
                <img
                  className="contact-me--right__image"
                  src={require("../../public/images/contact-me.jfif")}
                  alt="side"
                />
              </div>

              <div className="contact-me--right__social">
                <img
                  onClick={() =>
                    openAnotherTab(
                      history,
                      "https://www.facebook.com/vasilache.andrei46/"
                    )
                  }
                  className="contact-me--right__social__image"
                  src={require("../../public/icons/facebook.png")}
                  alt="side "
                />
                <img
                  onClick={() =>
                    openAnotherTab(history, "https://github.com/gfx96")
                  }
                  className="contact-me--right__social__image"
                  src={require("../../public/icons/github.png")}
                  alt="side "
                />
                <img
                  onClick={() =>
                    openAnotherTab(
                      history,
                      "https://www.linkedin.com/in/vasilache-andrei-741a1a158/"
                    )
                  }
                  className="contact-me--right__social__image"
                  src={require("../../public/icons/linkedin.png")}
                  alt="side "
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ContactMe;
